export default (state, { payload: { id, saved } }) => ({
  ...state,
  items: id // could check `ITEM_TYPE` from `state` instead...
    ? state.items.map(item => (item.id === id ? { ...item, saved } : item))
    : state.items
});
